import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import Header from '../Header';
import language from '../../../assets/languages/language';
import CustomCard from '../CustomCard';
import CustomButton from '../Button/CustomButton';
import PrintButton from './PrintButton';
import AppRoutes from '../../config/AppRoutes';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import LoaderWrapper from '../LoaderWrapper';
import alertMessage from '../../config/alertMessage';
import ModalComponent from '../../Common/Modal';
import { examNameAccordingToDB } from '../../../common/constant';
import { hasMockAccessFromBackend } from '../../../utils/CommonUtils';

export class ESGCBT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      dropdownOpenIndex: '',
      mockList: [],
      isLoading: true,
      openPremiumPopup: false,
      userSubscriptionDetails: {},
      hasMockSubscription: null,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    const result = await this.fetchMockList(data);
    if (result.success) {
      const { mockList, userSubscriptionDetails, hasMockSubscription } = result;
      this.setState({
        mockList,
        userSubscriptionDetails,
        hasMockSubscription: hasMockSubscription || null,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  fetchMockList = data => {
    return FD.callAPI(`${App_data.backend_api}/esg/cbt/mocks`, data);
  };

  // Subscription Modal Pop-up
  checkSubscription = (cb, ...params) => {
    const { userSubscriptionDetails, hasMockSubscription } = this.state;
    const hasStandardSubscription =
      userSubscriptionDetails && Object.keys(userSubscriptionDetails).length > 0;
    // Users with a mock-only package (e.g. ESG Mock Learn + Practice) get an
    // empty userSubscriptionDetails from subscriptionCheckMiddleware — fall
    // back to hasMockSubscription computed by cbtMockSubscriptionMiddleware.
    const hasMockAccess = hasMockAccessFromBackend(hasMockSubscription);
    if (!hasStandardSubscription && !hasMockAccess) {
      return this.setState({ openPremiumPopup: true });
    }
    cb(...params);
  };

  goPremium = async () => {
    this.context.router.push({
      pathname: '/Subscribe/',
    });
  };
  toggleAlert = () => {
    this.setState({
      openPremiumPopup: !this.state.openPremiumPopup,
    });
  };
  // Subscription Modal Pop-up

  toggle = index => {
    this.setState({
      dropdownOpenIndex: index,
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  viewAttemptedExams = item => {
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', item.id).replace(
        ':timer',
        item.timer,
      ),
    });
  };
  render() {
    const { dropdownOpen, dropdownOpenIndex, mockList, isLoading, openPremiumPopup } = this.state;
    return (
      <div className='animated fadeIn font-lusitana font-16px'>
        <Header title={language.LC().MOCK_LIST} />
        <LoaderWrapper isLoading={isLoading}>
          <CustomCard>
            <Row>
              <Col>
                <table className='table_white_bg table'>
                  <thead>
                    <tr className='border_top_0'>
                      <th width='90'>#</th>
                      <th className='mw-190'>{language.LC().MOCKEXAM}</th>
                      <th className='w-280 text-center'>{language.LC().ACTION}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mockList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.mock_order}</td>
                        <td>
                          <div>{item.mock_exam}</div>
                        </td>
                        <td>
                          <CustomButton
                            className='small-btn'
                            onClick={() => this.viewAttemptedExams(item)}
                          >
                            {language.LC().START}
                          </CustomButton>
                          <PrintButton
                            mockListLength={mockList.length}
                            index={index}
                            item={item}
                            dropdownOpen={dropdownOpen}
                            dropdownOpenIndex={dropdownOpenIndex}
                            toggle={() => this.checkSubscription(this.toggle, index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </CustomCard>
        </LoaderWrapper>
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_ESG}
          exam={examNameAccordingToDB.ESG}
        />
      </div>
    );
  }
}

export default ESGCBT;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/index.jsx